// extracted by mini-css-extract-plugin
export var compact = "_o5-2";
export var phoneFrame = "_o5-0";
export var phoneScreen = "_o5-1";